/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Paid_Only_LabelInputs */

const vi_order_export_paid_only_label = /** @type {(inputs: Order_Export_Paid_Only_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ xuất những đơn đã thanh toán hoặc thanh toán 1 phần`)
};

/**

* @param {Order_Export_Paid_Only_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_paid_only_label = /** @type {((inputs?: Order_Export_Paid_Only_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Paid_Only_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_paid_only_label(inputs)
});